import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue'
import { useRouter } from 'vue-router'

import { TripFullWithRelations } from '@/models/trip'

import { commonCase } from '@/helpers/strings'
import { normalizeUserName } from '@/helpers/user'
import { formatDateWithTime } from '@/helpers/date'
import { routeNames } from '@/router/route-names'
import { useTripsStore } from '@/store/trips'
import { useReviewsStore } from '@/store/reviews'
import { useAuthStore } from '@/store/auth'


export default /*@__PURE__*/_defineComponent({
  __name: 'ReviewsSection',
  props: {
    trip: {}
  },
  setup(__props: any) {

const props = __props
const router = useRouter()
const tripsStore = useTripsStore()
const reviewsStore = useReviewsStore()
const authStore = useAuthStore()

const isAdmin = computed(() => authStore.session?.user.role === 'admin')

const reviewsMap = computed(() => ({
  hostReview: props.trip.reviews.filter(
    ({ user_id }) => user_id === props.trip.host_id
  ),
  renterReview: props.trip.reviews.filter(
    ({ user_id }) => user_id === props.trip.renter_id
  ),
}))

const showReviewDetails = (id: string) => {
  router.push({ name: routeNames.reviewDetails, params: { id } })
}

const deleteReview = async (id: string) => {
  await reviewsStore.deleteReview(id)
  await tripsStore.deletePreviewFromTripsDetails(props.trip.id, id)
}

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[2] || (_cache[2] = _createElementVNode("h4", { class: "title" }, "Reviews section", -1)),
    _createVNode(_component_el_row, { class: "reviews-container" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reviewsMap.value, (reviews, key) => {
          return (_openBlock(), _createBlock(_component_el_col, {
            key: key,
            span: 24
          }, {
            default: _withCtx(() => [
              _createElementVNode("h5", null, _toDisplayString(_unref(commonCase)(key, true)), 1),
              _createVNode(_component_el_table, {
                border: "",
                data: reviews,
                style: {"width":"100%"},
                "show-header": false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "id",
                    width: "250px"
                  }),
                  _createVNode(_component_el_table_column, { "class-name": "body-cell" }, {
                    default: _withCtx(({ row }) => [
                      _createElementVNode("div", null, _toDisplayString(key === 'hostReview' ? 'Host' : 'Renter') + ": " + _toDisplayString(_unref(normalizeUserName)(
                    key === 'hostReview' ? _ctx.trip.host : _ctx.trip.renter
                  )), 1),
                      _createElementVNode("div", null, "Score: " + _toDisplayString(row.score), 1),
                      _createElementVNode("div", null, " Review date-time: " + _toDisplayString(_unref(formatDateWithTime)(row.created_at)), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_table_column, {
                    width: "160px",
                    "class-name": "action-cell"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createVNode(_component_el_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                plain: "",
                                type: "primary",
                                size: "small",
                                style: {"width":"100%"},
                                icon: "el-icon-view",
                                onClick: ($event: any) => (showReviewDetails(row.id))
                              }, {
                                default: _withCtx(() => _cache[0] || (_cache[0] = [
                                  _createTextVNode(" Show details ")
                                ])),
                                _: 2,
                                __: [0]
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024),
                          (isAdmin.value)
                            ? (_openBlock(), _createBlock(_component_el_row, { key: 0 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_button, {
                                    plain: "",
                                    style: {"width":"100%","margin-top":"10px"},
                                    type: "primary",
                                    size: "small",
                                    icon: "el-icon-view",
                                    onClick: ($event: any) => (deleteReview(row.id))
                                  }, {
                                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                                      _createTextVNode(" Delete review ")
                                    ])),
                                    _: 2,
                                    __: [1]
                                  }, 1032, ["onClick"])
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["data"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    })
  ], 64))
}
}

})